export const LEAD_TAG_NAME_MAX_LENGTH = 30;

export const cleanLeadTagName = (raw: string): string => raw.trim().replace(/\s+/g, " ");

export const normalizeLeadTagName = (raw: string): string =>
  cleanLeadTagName(raw).normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
